import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { canOperatePos } from '@/lib/pos-roles';

interface RoleGateProps {
  role?: string;
}

/** Allow the cashier role (and superadmin/admin pass-through) to reach the POS. */
export function RoleGate({ role = 'cashier' }: RoleGateProps) {
  const user = useAuthStore((s) => s.user);
  const ok = user && (user.role === role || canOperatePos(user.role));

  if (!ok) {
    return <Navigate to="/login" replace state={{ error: 'ROLE_NOT_ALLOWED' }} />;
  }
  return <Outlet />;
}
